import { Outlet, createRoute } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { AreaSidebar, ProductGuard, ProductLayout } from '@/app/routes/area-layout'

export function DataCollectionLayout() {
  return (
    <ProductGuard product="data-collection">
      <ProductLayout sidebar={<AreaSidebar area="dataCollection" />}>
        <Outlet />
      </ProductLayout>
    </ProductGuard>
  )
}

export const dataCollectionRoute = createRoute({
  getParentRoute: () => entityRoute,
  id: 'data-collection',
  component: DataCollectionLayout,
})
